import React from 'react';
import styled from 'styled-components';

export interface IconProps extends React.AllHTMLAttributes<HTMLDivElement> {
  width?: number;
  height?: number;
  viewBox?: string;
  color?: string;
}

export const StyledBaseIcon = styled.svg``;
const BaseIcon = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
  children,
  color = 'none'
}: IconProps) => {
  return (
    <StyledBaseIcon width={width} height={height} viewBox={viewBox} fill={color}>
      {children}
    </StyledBaseIcon>
  );
};

export default BaseIcon;
